import { gql, useLazyQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { useEffect } from "react";

const FETCH_FACTORY_QC_ISSUE_IMAGES = gql`
  query FETCH_FACTORY_QC_ISSUE_IMAGES(
    $id: ID!
    $productId: ID!
    $defectCodeId: ID!
    $start: DateTime!
    $end: DateTime!
  ) {
    factoryQcIssueImages(
      id: $id
      productId: $productId
      defectCodeId: $defectCodeId
      startDate: $start
      endDate: $end
    )
  }
`;

const DefectCodeImages = ({ factoryId, productId, defectCode, start, end }) => {
  const [fetchImages, { loading, error, data, called }] = useLazyQuery(
    FETCH_FACTORY_QC_ISSUE_IMAGES,
  );

  useEffect(() => {
    fetchImages({
      variables: {
        id: factoryId,
        productId,
        defectCodeId: defectCode.id,
        start,
        end,
      },
    }).catch(() => null);
  }, [defectCode.id, end, factoryId, fetchImages, productId, start]);

  const images = data ? JSON.parse(data.factoryQcIssueImages) : [];

  return (
    <div>
      {error ? (
        <Errors error={error} />
      ) : images.length ? (
        <div className="flex gap-3 overflow-x-auto pb-2">
          {images.map((src, index) => (
            <a
              href={src}
              target="_blank"
              rel="noreferrer"
              key={`${src}-${index}`}
              className="flex-shrink-0"
            >
              <img
                src={`${src}?imageView2/2/w/160`}
                alt={defectCode.description}
                loading="lazy"
                className="w-40"
              />
            </a>
          ))}
        </div>
      ) : !called || loading ? (
        <InlineSpinner text="Loading images..." />
      ) : (
        <div className="flex min-h-[220px] items-center justify-center text-sm opacity-60">
          No images for this issue.
        </div>
      )}
    </div>
  );
};

export default DefectCodeImages;
